import apiHandler from "../../../../api/core/apiHandler";

const paymentHistoryCxpApi =
  apiHandler("payables");

export default paymentHistoryCxpApi;